import { FC, createElement, type JSX } from 'react'
import { cn } from '../utils/cn'

import type { CreateComponentsUnion } from '../types'

// NOTE: We can't use string interpolation or template literals
// tailwind doesn't understand what className to include into bundle on runtime
/** @public */
export const CENTER_HORIZONTAL_GAPS = {
  0: 'px-0',
  px: 'px-px',
  '0.5': 'px-0.5',
  1: 'px-1',
  1.5: 'px-1.5',
  2: 'px-2',
  2.5: 'px-2.5',
  3: 'px-3',
  '3.5': 'px-3.5',
  4: 'px-4',
  5: 'px-5',
  6: 'px-6',
  7: 'px-7',
  8: 'px-8',
  9: 'px-9',
  10: 'px-10',
  11: 'px-11',
  12: 'px-12',
  14: 'px-14',
  16: 'px-16'
}

/**
 * @public
 */
export type CenterProps = CreateComponentsUnion<
  keyof JSX.IntrinsicElements,
  {
    innerCentering?: boolean
    horizontalGaps?: keyof typeof CENTER_HORIZONTAL_GAPS
  }
>

export const Center: FC<CenterProps> = ({
  as = 'div',
  horizontalGaps = 6,
  innerCentering = false,
  className,
  children,
  ...props
}) => {
  const centerClassName = cn(
    'relative mx-auto box-content',
    CENTER_HORIZONTAL_GAPS[horizontalGaps],
    className,
    {
      'flex flex-col items-center': innerCentering
    }
  )
  return createElement(as, { ...props, className: centerClassName }, children)
}
